export default __webpack_public_path__ + "static/Gunpowder-2c8673c48b6b780d6d9a3734abf5ad22.png";